import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Link from "@mui/material/Link";
import { useDispatch, useSelector } from "react-redux";
import { storeAttestation } from "./AttestationApi";
import { actionAttestationUpdated } from "./authRedux";

export default function AttestationDialog() {
  const showAttestation = useSelector(
    (state) => state.authReducer.showAttestation,
  );

  if (!showAttestation) {
    return null;
  }

  return (
    <Dialog
      open={true}
      maxWidth="sm"
      fullWidth
      aria-labelledby="attestation-dialog-title"
      aria-describedby="attestation-dialog-description"
    >
      <DialogTitle id="attestation-dialog-title">
        Annual Attestation
      </DialogTitle>

      <DialogContent dividers>
        <DialogContentText id="attestation-dialog-description">
          MGIS access is provided for authorized University business purposes
          only. By selecting &quot;I Agree,&quot; you acknowledge this annual
          attestation and agree to protect MGIS information, use it responsibly,
          and avoid unauthorized sharing or reuse of data. To learn more, review
          the{" "}
          <Link
            href="https://docs.google.com/document/d/12Z9Cwa78V2ab3Vbzc6ZTX-IqB7Czw8vowlEsTpvKnSI/edit?tab=t.0#heading=h.hz5e4qs0ik51"
            target="_blank"
            rel="noreferrer"
            underline="always"
          >
            MGIS Access, Use & Sharing Guidelines
          </Link>
          . Your acceptance will be recorded for security and compliance
          purposes.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ padding: 2 }}>
        <AgreeButton />
      </DialogActions>
    </Dialog>
  );
}

function AgreeButton() {
  const dispatch = useDispatch();
  const buttonClicked = () => {
    dispatch(actionAttestationUpdated({ showAttestation: false }));
    storeAttestation();
  };

  return (
    <Button
      variant="contained"
      onClick={buttonClicked}
      autoFocus
      disableRipple
      sx={{
        minHeight: 44,
        px: 3,
      }}
    >
      I Agree
    </Button>
  );
}
